module.exports = __webpack_public_path__ + "img/scene_13.5e8632a1.jpg";